import { DateValidator } from '@buses/bus-results/entities/bus-search-payload';
import { BusType } from '@search-bar/entities/bus-type';

type NumberType = number;

const addStartDate: NumberType = 15;
const addEndDate: NumberType = 20;

export function dateValidationByBuses(departure: Date, busType: BusType, arrival?: Date): DateValidator {
  const currentDateArrival = new Date();
  const currentDateDeparture = new Date();

  currentDateArrival.setHours(0, 0, 0, 0);
  currentDateDeparture.setHours(0, 0, 0, 0);

  if (busType === BusType.ONEWAY) {
    departure.setHours(0, 0, 0, 0);
    if (departure < currentDateDeparture) {
      currentDateDeparture.setDate(currentDateDeparture.getDate() + addStartDate);
      return {
        departure: currentDateDeparture,
        valid: false
      };
    } else return { departure, valid: true };
  } else if (busType === BusType.ROUNDTRIP) {
    departure.setHours(0, 0, 0, 0);
    arrival.setHours(0, 0, 0, 0);
    if (arrival < currentDateArrival || departure < currentDateDeparture) {
      currentDateDeparture.setDate(currentDateDeparture.getDate() + addStartDate);
      currentDateArrival.setDate(currentDateArrival.getDate() + addEndDate);
      return {
        arrival: currentDateArrival,
        departure: currentDateDeparture,
        valid: false
      };
    } else return { arrival, departure, valid: true };
  }
}
